var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationError = function SvgLocationError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960"
  }, props), /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: -300,
    fill: "red",
    style: {
      fontSize: 500
    },
    textAnchor: "middle"
  }, "\n    ?\n  "), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M450-40v-75q-137-14-228-105T117-448H42v-60h75q14-137 105-228t228-105v-75h60v75q137 14 228 105t105 228h75v60h-75q-14 137-105 228T510-115v75zm30-134q125 0 214.5-89.5T784-478t-89.5-214.5T480-782t-214.5 89.5T176-478t89.5 214.5T480-174"
  })));
};
export default SvgLocationError;